import { Injectable } from '@angular/core';
import { AttendanceChannel } from 'src/app/modules/live-chat/interfaces/attendance';

@Injectable({
    providedIn: 'root'
})
export class checkLimitChannelService {

    constructor() { }
    protected readonly MAX_LENGTH_FACEBOOK_WEB_CHAT = 1600;
    protected readonly MAX_LENGTH_WHATSAPP = 3500;
    protected readonly MAX_LENGTH_INSTAGRAM = 1000;

    calculateExceededLimit(content: string, channelAttendance?: AttendanceChannel): boolean {
        content = this.removeLineBreaksAndTags(content)
        switch (channelAttendance) {
            case AttendanceChannel.WHATSAPP:
                return content.length > this.MAX_LENGTH_WHATSAPP;
            case AttendanceChannel.INSTAGRAM:
                return content.length > this.MAX_LENGTH_INSTAGRAM;
            case AttendanceChannel.CHAT_WEB:
            case AttendanceChannel.FACEBOOK:
                return content.length > this.MAX_LENGTH_FACEBOOK_WEB_CHAT;
            default:
                return false;
        }
    }

    removeLineBreaksAndTags(text: string): string {
        let withoutTags = text.replace(/<\/?[^>]+(>|$)/g, " ");
        withoutTags = withoutTags.replace(/[\r\n]+/g, " ").replace(/\s+/g, " ");
        return withoutTags.trim();
    }
}
